import React, { useContext, useState } from 'react';
import { AudioContext } from '../../libs/audio-provider';
import Modal from '../ui/Modal';
import SvgButton from '../ui/SvgButton';

interface GameGunpowderHintsAndDescriptionModalProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  lives: number,
}

function GameGunpowderHintsAndDescriptionModal(props: GameGunpowderHintsAndDescriptionModalProps) {
  const { playClick } = useContext(AudioContext);
  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      <div className="lives-and-hints">
        <div className="lives-and-hints-counter-wrapper">
          <div className={`lives-and-hints-counter${props.lives > 2 ? '' : ' lives-and-hints-counter-used'}`}></div>
          <div className={`lives-and-hints-counter${props.lives > 1 ? '' : ' lives-and-hints-counter-used'}`}></div>
          <div className={`lives-and-hints-counter${props.lives > 0 ? '' : ' lives-and-hints-counter-used'}`}></div>
        </div>

        <button className="hints-button" onClick={() => { playClick(); setModalShow(true) }}>  </button>
        {modalShow
          ? <Modal>
            <div className="modal modal-game-gunpowder game-intro-1">
              <button className="button modal-button-close" onClick={() => { playClick(); setModalShow(false) }}>
                <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/game-gunpowder/close-button`} src1=".svg" src2="-select.svg" alt="關閉"></SvgButton>
              </button>
              <div className="modal-content">
              </div>
            </div>
          </Modal>
          : null}
      </div>
    </>
  );
}

export default GameGunpowderHintsAndDescriptionModal;
